import { API_ROUTES } from '@/constants/apiRoutes';
import { AxiosInstance } from 'axios';
import { CreateSubDomainPayload } from './subDomain.types';

const createSubDomain = (client: AxiosInstance) => async (payload: CreateSubDomainPayload) => {
  return (await client.post<{ message: string; data: unknown }>(API_ROUTES.MANAGE_SUB_DOMAIN, payload)).data;
};
export const subDomainMutations = {
  createSubDomain,
};
